// Central mapping between the "Information & Reports" nav menu and the
// backend Report resource (category + sub_category).
//
// basePath === "" means the sub menu links are flat (e.g. /policies).
// Otherwise links are nested as /<basePath>/<slug> (e.g. /camp-reports/annual-camp-reports).

export const REPORT_CATEGORIES = [
  {
    category: "POLICIES_MANUALS",
    title: "Policies, Manuals, Regulations and Guidelines",
    basePath: "",
    subcategories: [
      { slug: "policies", label: "Policies" },
      { slug: "manuals", label: "Manuals" },
      { slug: "regulations", label: "Regulations" },
      { slug: "guidelines", label: "Guidelines" },
    ],
  },
  {
    category: "ADMINISTRATIVE_REPORTS",
    title: "Administrative Reports",
    basePath: "administrative-reports",
    subcategories: [
      { slug: "annual-nss-unit-reports", label: "Annual NSS Unit Reports" },
      { slug: "clac-minutes-mom", label: "CLAC Minutes and Other MoM" },
      { slug: "action-taken-reports", label: "Action Taken Reports" },
      { slug: "enrolment-reports", label: "Enrolment Reports" },
      { slug: "service-completion-reports", label: "Service Completion Reports" },
      { slug: "financial-reports", label: "Financial Reports" },
      { slug: "nss-best-practices-report", label: "NSS Best Practices Report" },
      { slug: "social-impact-assessment-reports", label: "Social Impact Assessment Reports" },
      { slug: "industry-collaboration-reports", label: "Industry Collaboration Reports" },
      { slug: "mous", label: "MoUs" },
      { slug: "adopted-village-reports", label: "Adopted Village Reports" },
      { slug: "achievement-and-awards-reports", label: "Achievement and Awards Reports" },
      { slug: "press-publicity-reports", label: "Press & Publicity Reports" },
      { slug: "other-reports", label: "Other Reports" },
    ],
  },
  {
    category: "ACTIVITY_EVENT_REPORTS",
    title: "Activity & Event Reports",
    basePath: "activity-event-reports",
    subcategories: [
      { slug: "nss-annual-calendar", label: "NSS Annual Calendar" },
      { slug: "elp-cbp-reports", label: "ELP and CBP Reports" },
      { slug: "health-wellness-activities", label: "Health and Wellness Activities" },
      { slug: "environmental-cleanliness-initiatives", label: "Environmental & Cleanliness Initiatives" },
      { slug: "awareness-social-campaigns", label: "Awareness & Social Campaigns" },
      { slug: "education-training-programmes", label: "Education & Training Programmes" },
      { slug: "community-outreach-services", label: "Community Outreach & Services" },
    ],
  },
  {
    category: "CAMP_REPORTS",
    title: "Camp Reports",
    basePath: "camp-reports",
    subcategories: [
      { slug: "annual-camp-reports", label: "Annual Camp Reports" },
      { slug: "special-camp-reports", label: "Special Camp Reports" },
      { slug: "national-level-camp-reports", label: "National-Level Camp Reports" },
      { slug: "regional-state-level-camp-reports", label: "Regional & State-Level Camp Reports" },
      { slug: "thematic-camp-reports", label: "Thematic Camp Reports" },
    ],
  },
];

// Build the front-end route path for a category + sub menu slug.
export function buildReportPath(basePath, slug) {
  return basePath ? `/${basePath}/${slug}` : `/${slug}`;
}

// Resolve a pathname (e.g. "/camp-reports/special-camp-reports" or "/policies")
// to { category, sub_category, label, parentTitle }. Returns null if no match.
export function resolveReport(pathname) {
  const clean = (pathname || "").replace(/\/+$/, ""); // strip trailing slash
  for (const cat of REPORT_CATEGORIES) {
    for (const sub of cat.subcategories) {
      if (buildReportPath(cat.basePath, sub.slug) === clean) {
        return {
          category: cat.category,
          sub_category: sub.slug,
          label: sub.label,
          parentTitle: cat.title,
        };
      }
    }
  }
  return null;
}
